<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="w-full flex justify-between items-center bg-blue-200 text-sm px-4 py-2 mb-4">
      提示: 待提现推广订单合计佣金金额大于等于100可以申请提现，推广订单完成支付后订单进入待审核状态，待官方审核通过后推广订单进入30天结算期，结算期结束后进入待提现状态即可申请提现。
    </div>
    <div class=" w-full  flex justify-between items-center">
      <div class="">
        <input v-model="query.keyword" type="text" name="first-name" placeholder="关键字筛选" autocomplete="given-name" class="mt-1 mr-4 inline-block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
      </div>
      <a href="javascript:;" type="button" @click="withdrawal" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-1 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto cursor-pointer">提现选中的订单</a>
    </div>
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <input type="checkbox" name="check_all" v-model="checkAll" @change="checkboxAllChange($event)">
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">订单号</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">用户名</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">实付金额</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">佣金金额</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">佣金比例</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">状态</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
                  <!-- <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th> -->
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.Key">
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <input type="checkbox" v-model="checkedList[item.Key]" @change="checkboxChange($event, item.Key)">
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.OrderNo}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.OrderUser.nick_name || item.OrderUser.user_name}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">￥{{item.OrderRealAmount}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">￥{{item.RebateAmount}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{parseInt(item.RebateRatio * 100)}}%</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.Status === 6" class="text-green-600">已打款</span>
                    <span v-else-if="item.Status === 5" class="text-green-400">待打款</span>
                    <span v-else-if="item.Status === 4" class="text-green-300">待提现</span>
                    <span v-else-if="item.Status === 3" class="text-lime-300" :title="'剩余可提现天数：' + Math.ceil(item.TimeRemaining / (24 * 3600))">结算中</span>
                    <span v-else-if="item.Status === 2" class="text-teal-300">已审核</span>
                    <span v-else-if="item.Status === 1" class="text-cyan-300">待审核</span>
                    <span v-else-if="item.Status === 0" class="text-[#f00]">未支付</span>
                    <span v-else-if="item.Status === -1" class="text-[#f00]">未通过</span>
                    <span class="text-red" v-else>--</span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.AddTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <!-- <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="删除" @click="deleteItem(item.Key)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                      </svg>
                    </a> -->
                    <!-- <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="提现" @click="withdrawal(item.Key)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3" />
                      </svg>
                    </a> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="versionDialog" title="" :ActionBtnShow="false" width="max-w-3xl">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4 mx-2"></div>
    </Modal>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination.vue'
import Alert from '../../components/Alert.vue'
import Notify from '../../components/Notification.vue'
import { pageRebateList as pageList, removeRebateList as remove, withdrawalRequest } from '../../api/Rebate'
import { debounce } from 'lodash'
import Modal from '../../components/Modal.vue'
export default {
  name: 'ScoreList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      versionDialog: false,
      checkAll: false,
      query: {
        PageIndex: 1,
        PageSize: 10,
        Keyword: '',
        Sort: '-id'
      },
      key: '',
      versions: [],
      tableData: [],
      total: 0,
      user: { score: 0 },
      checkedList: {}
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    checkboxAllChange (event) {
      if (event.target.checked) {
        this.tableData.map(i => {
          this.checkedList[i.Key] = true
        })
      } else {
        this.tableData.map(i => {
          this.checkedList[i.Key] = false
        })
      }
    },
    checkboxChange (event, key) {
      if (event.target.checked) {
        this.checkedList[key] = true
      } else {
        this.checkedList[key] = false
      }
      this.checkAll = Object.values(this.checkedList).every((i) => { return i })
    },
    withdrawal () {
      const data = []
      Object.keys(this.checkedList).map(i => {
        if (this.checkedList[i]) data.push(i)
      })
      if (!data.length) {
        this.notifyShow({ title: '无选中的订单', type: 'error' })
        return
      }
      withdrawalRequest(data).then((res) => {
        if (res.data.code === -1) {
          this.notifyShow({ title: res.data.message, type: 'error' })
          return
        }
        this.notifyShow({ title: '提现请求提交成功' })
        this.getList()
      })
    },
    deleteItem (key) {
      this.alertShow = true
      this.alterMsg = undefined
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        remove(key).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      this.checkedList = {}
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.tableData.map(i => {
          this.checkedList[i.Key] = false
        })
        this.query.PageIndex = data.page
        this.total = data.total
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
